<template>
    <div class="order-list">
        <div class="order-container">
            <div class="search-box">
                <div class="item">
                    <span class="text">訂單編號：</span>
                    <a-input style="width:200px;" placeholder="订单编号" v-model="para.orderCode"></a-input>
                </div>
                <div class="item">
                    <span class="text">收件人名字：</span>
                    <a-input style="width:200px;" placeholder="姓名" v-model="para.receiverName"></a-input>
                </div>
                <div class="item">
                    <span class="text">收件人手機：</span>
                    <a-input style="width:200px;" placeholder="手机号" v-model="para.receiverPhone"></a-input>
                    <a-button style="margin-left:20px;" @click="search">搜索</a-button>
                </div>
            </div>
            <a-table :pagination="false" :loading="tbLoading" :data-source="list" row-key="id">
                <a-table-column
                        align="center"
                        title="商品信息">
                    <template slot-scope="row,item">
                        <div class="pro-box">
                            <img :src="item.orderItemResponse.productImages[0]" alt="" class="pro-img">
                            <p class="pro-name">{{item.orderItemResponse.productTitle}}</p>
                          <p class="sku-name">
                            商品属性:{{ item.orderItemResponse.skuDesc ? item.orderItemResponse.skuDesc : '默认' }}</p>
                          <p class="pro-num">数量：{{ item.orderItemResponse.buyNum }}</p>
                        </div>
                    </template>
                </a-table-column>
                <a-table-column
                        align="center"
                        title="收件人信息">
                    <template slot-scope="row,item">
                        <p>{{item.receiverInfo.receiverName}}</p>
                        <p>{{item.receiverInfo.receiverPhone}}</p>
                        <p>{{item.receiverInfo.provinceName + ' ' + item.receiverInfo.cityName + ' ' + (item.receiverInfo.districtName ? item.receiverInfo.districtName : '') + ' ' + item.receiverInfo.addressDetail}}</p>
                    </template>
                </a-table-column>
                <a-table-column
                        align="center"
                        title="訂單編號"
                        data-index="orderCode"></a-table-column>
                <a-table-column
                        align="center"
                        title="訂單金額">
                  <template slot-scope="row,item">
                    <span class="red">訂單總額：¥{{(item.orderAmount/100).toFixed(2)}}元</span><br>
                    <span class="red">訂單郵費：¥{{item.postageAmount > 0 ?(item.postageAmount/100).toFixed(2) + '元' : '包郵'}}</span>
                  </template>
                </a-table-column>
                <a-table-column
                        align="center"
                        title="操作時間">
                    <template slot-scope="row,item">
                        <p>下單時間：{{item.orderTime | trans-date}}</p>
                        <p v-if="item.payTime">支付時間：{{item.payTime | trans-date}}</p>
                    </template>
                </a-table-column>
                <a-table-column
                        align="center"
                        title="操作">
                    <template slot-scope="row,item">
                        <a-space>
                            <a-button size="small" @click="del(item)" type="link" v-if="item.deleteState === 10 && item.orderState === 0">刪除</a-button>
                            <a-button size="small" @click="chanel(item)" type="link" v-if="item.orderState !== 0">取消訂單</a-button>
                            <a-button size="small" @click="pay(item)" type="link" v-if="item.orderState === 10">已支付</a-button>
                        </a-space>
                    </template>
                </a-table-column>
            </a-table>
            <a-pagination :defaultPageSize="para.pageSize" :defaultCurrent="para.pageIndex" :total="total" @change="currentChange" />
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                confirmLoading:false,
                tbLoading:false,
                list:[],
                para:{
                    orderCode:undefined,
                    orderState:10,
                    receiverName:undefined,
                    receiverPhone:undefined,
                    pageIndex:1,
                    pageSize:8
                },
                hide:false,
                total:0,
                sendShow:false,
                exNum:undefined,
                sendId:undefined
            }
        },
        methods: {
            pay(item){
                let self=this;
                this.$Confirm({
                    title: '提示',
                    content: '確定要將狀態改為已支付嗎？',
                    onOk() {
                        return new Promise((resolve, reject) => {
                            self.$http({
                                method: 'post',
                                url: '/manager/order/pay',
                                data:{
                                    id:item.id
                                },
                            }).then(res=>{
                                self.$Message.success('操作成功');
                                self.getList()
                                resolve();
                            }).catch(err=>{
                                reject()
                            })
                        })
                    },
                    onCancel() {},
                });
            },
            chanel(item){
                let self=this;
                this.$Confirm({
                    title: '提示',
                    content: '確定要取消該訂單嗎？',
                    onOk() {
                        return new Promise((resolve, reject) => {
                            self.$http({
                                method: 'post',
                                url: '/manager/order/cancel',
                                data:self.qs.stringify({
                                    id:item.id
                                }),
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            }).then(res=>{
                                self.$Message.success('操作成功');
                                self.getList()
                                resolve();
                            }).catch(err=>{
                                reject()
                            })
                        })
                    },
                    onCancel() {},
                });
            },
            currentChange(val){
                this.para.pageIndex=val;
                this.getList();
            },
            search(){
                this.para.pageIndex=1;
                this.getList();
            },
            getList(){
                let self=this;
                this.tbLoading=true;
                self.$http({
                    method: 'post',
                    url: '/manager/order/list',
                    data:self.para
                }).then(res=>{
                    self.tbLoading=false;
                    self.list=res.data && res.data.list ? res.data.list :[]
                    self.total=res.data && res.data.totalRows ? res.data.totalRows : 0
                })
            },
            del(item){
                let self=this;
                this.$Confirm({
                    title: '提示',
                    content: '確定要刪除該訂單嗎？',
                    onOk() {
                        return new Promise((resolve, reject) => {
                            self.$http({
                                method: 'post',
                                url: '/manager/order/delete',
                                data:self.qs.stringify({
                                    id:item.id
                                }),
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            }).then(res=>{
                                self.$Message.success('下架成功');
                                self.getList();
                                resolve();
                            }).catch(err=>{
                                reject()
                            })
                        })
                    },
                    onCancel() {},
                });
            },
        },
        created() {
            this.getList();
            this.$emit('breadcrumbChange',['賬號管理','未付款訂單管理'])
        },
    }
</script>
<style lang="less">
    .order-list{
        .red{
            color:#ff3657;
        }
        .order-container{
            padding:20px;
            .search-box{
                margin-bottom:20px;
                overflow: hidden;
                .item{
                    float:left;
                    margin-right:20px;
                    margin-bottom:20px;
                    .text{
                        font-size: 14px;
                        color:#333;
                    }
                }
            }
            .red{
                color:#ff3657;
            }
          .pro-box {
            display: flex;
            position: relative;
            .sku-name {
              position: absolute;
              bottom: 0;
              left: 120px;
              color:#e98821;
              text-align: left;
              font-size: 12px;
            }
            .pro-num{
              position: absolute;
              bottom:-20px;
              color:#e98821;
              left:120px;
              font-size: 12px;
            }
            .pro-img {
              width: 100px;
              height: 100px;
              object-fit: cover;
              display: block;
              margin-right: 20px;
            }

            .pro-name {
              color: #333;
              text-align: left;
              font-size: 14px;
              max-width: 200px;
            }
          }
        }
    }
</style>